import { render } from "./BlFormDeferredList.vue?vue&type=template&id=55f5fcb6&scoped=true"
import script from "./BlFormDeferredList.vue?vue&type=script&lang=js"
export * from "./BlFormDeferredList.vue?vue&type=script&lang=js"

import "./BlFormDeferredList.vue?vue&type=style&index=0&id=55f5fcb6&scoped=true&lang=css"

import exportComponent from "/tmp/3a52593b-0c57-4976-8665-ec4c8a4d9b76/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f5fcb6"]])

export default __exports__